module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Leistungen_full.19998af2.jpg";